/**
 * This file reads end point from WWW
 */
export default {
    getWWWURL() {
        return WP_WWW_URL;
    },
};
